module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAAABHNCSVQICAgIfAhkiAAAAS9JREFUOE/tlNGRglAMRX3QAFagdqAVLHZACdqB/gO+Bf53S6AErUCsQOzADqQBwBNcd1BU8F9mMjAvLzc3ITdKa23lef6jlJr13ntSwzDmxKfK9/24LEuH+AXvY0cci6QaGwRB0BcQYss5B0MAVl1AuJ+YprksimKPTSsQ+YDaFucOsKQD0Ooa0wAh+Bt6ug2knvgDcunWpyfNqXnZExnnjhOrn02s/YZ2dmjHAeh0M7FRFDU0g8zHXBKlbh5J4VrWvwDvQbggGqpULWWGYTi9B2oF8TwvpT9rmCSicGwEs5t90woiy4rMX1gGkxFMrKdMyJiRMabuRf2SrE1YSEkWLH5lDdb9ruvafwwn0pOqdqm7bY/U/SQeE3OAoa3EAZsZhw6HDcovgNf85hiG2Rl5uILKllLx4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-phone02.png
// module id = QRBK
// module chunks = 92